import { PromptEditor } from "@/components/PromptEditor";

const Demo = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-4xl space-y-8">
        <div className="text-center space-y-2">
          <h1 className="text-4xl font-bold tracking-tight text-slate-900">Zero-Hallucination Prompt Editor</h1>
          <p className="text-slate-500 text-lg">Detect and fix logical conflicts in your AI image prompts before you hit generate.</p>
        </div>
        
        <PromptEditor 
          initialValue="A beautiful indoor sunset over the Grand Canyon with cinematic lighting and flat light." 
        />
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          <div className="p-4 bg-white rounded-lg border border-slate-200 shadow-sm">
            <h3 className="font-semibold mb-2 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-red-500" />
              Logic Validation
            </h3>
            <p className="text-slate-600">Automatically detects contradictions like "Indoor" vs "Grand Canyon".</p>
          </div>
          <div className="p-4 bg-white rounded-lg border border-slate-200 shadow-sm">
            <h3 className="font-semibold mb-2 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-blue-500" />
              Smart Fixes
            </h3>
            <p className="text-slate-600">Click highlighted terms to see explanations and apply logical alternatives.</p>
          </div>
          <div className="p-4 bg-white rounded-lg border border-slate-200 shadow-sm">
            <h3 className="font-semibold mb-2 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-amber-500" />
              Magic Enhance
            </h3>
            <p className="text-slate-600">Fix all logical errors instantly with a single click using the sparkle button.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Demo;
